import * as React from "react"
import { connect } from "react-redux"

import {
    Body,
    CompleteFooter,
    Table,
    RowContentCell,
    LoadingBody,
} from "@tenforce/toolbox-table-react"

import { GlobalState } from "../../../store"
import WorkspaceTableHeader from "./WorkspaceTableHeader"
import LoadMore from "./LoadMore"
import WorkspaceRow from "./WorkspaceRow"
import OldUIContext from "../../../olduicontext"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../util/Translations"
import { IWorkspaceListPage } from "../index"

type StateProps = IWorkspaceListPage

type Props = StateProps

export class WorkspaceListPage extends React.Component<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const {
            isLoading,
            workspaces,
            pagination: { count },
        } = this.props

        const { Workspaces, _of, NoResultsFound } = Labels

        const hasMore = workspaces.length < count

        return (
            <Table data-ft-workspaces-table>
                <WorkspaceTableHeader />
                {isLoading && workspaces.length === 0 ? (
                    <LoadingBody id="workspaceListLoading" />
                ) : (
                    <Body
                        extraClasses={`${isLoading ? "is-loading" : ""}`}
                        id={`${
                            isLoading ? "workspaceListLoading" : "workspaceList"
                        }`}
                    >
                        {workspaces.length === 0 && (
                            <RowContentCell id="workspacesNothingFound">
                                <span className="is-dimmed tw-pl-6">
                                    {NoResultsFound}
                                </span>
                            </RowContentCell>
                        )}
                        {workspaces.map((workspace) => (
                            <WorkspaceRow
                                key={workspace.id}
                                workspace={workspace}
                            />
                        ))}
                        {hasMore && <LoadMore />}
                    </Body>
                )}
                <CompleteFooter>
                    <div
                        className={`label is-dimmed tw-pl-2 ${
                            isLoading ? "is-loading is-placeholder" : ""
                        }`}
                    >
                        {isLoading ? (
                            <>
                                {Symbols.PlaceholderSmall}&nbsp;
                                {Symbols.PlaceholderTiny}&nbsp;
                                {Symbols.PlaceholderSmall}&nbsp;
                                {Symbols.PlaceholderMedium}
                            </>
                        ) : (
                            <>
                                {hasMore && (
                                    <>
                                        <span
                                            data-ft-component="numberOfVisibleWorkspaces"
                                            data-ft-count={workspaces.length}
                                        >
                                            {workspaces.length}
                                        </span>
                                        &nbsp;{_of}&nbsp;
                                    </>
                                )}
                                <span
                                    data-ft-component="numberOfWorkspaces"
                                    data-ft-count={count}
                                >
                                    {count}
                                </span>
                                &nbsp;{Workspaces}
                            </>
                        )}
                    </div>
                </CompleteFooter>
            </Table>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.workspaceListPage,
})

export default connect(mapStateToProps, {})(WorkspaceListPage)
